/* istanbul ignore file */
import React from 'react'
import * as blueprint from '@adc/blueprint'
import ScrollSpy from '../../../layouts/scrollspy'

export class AdditionalTermsBadge extends blueprint.listing.badges
  .AdditionalTermsBadge {
  get content() {
    return (
      <>
        Review additional documents{' '}
        <ScrollSpy selector='#due_diligence'>
          {({ scrollTo }) => <a onClick={scrollTo}>{` here`}</a>}
        </ScrollSpy>
        .
      </>
    )
  }
}
